import { useNavigate } from 'react-router-dom';
import { Badge, IconButton } from '@mui/material';

import NotificationIcon from '../../../assets/icons/notificationIcon.svg?react';
import { ROUTES } from '../../../constants/routes';
import { useUnreadCountQuery } from '../../../hooks/useNotifications';

export const CabinetNotificationBell = () => {
  const navigate = useNavigate();
  const { data: unreadData } = useUnreadCountQuery();
  const unreadCount = unreadData?.count ?? 0;

  return (
    <IconButton onClick={() => navigate(`/${ROUTES.CABINET}/${ROUTES.NOTIFICATIONS}`)} sx={{ p: 0 }}>
      <Badge
        badgeContent={unreadCount}
        max={99}
        sx={{
          '& .MuiBadge-badge': {
            background: '#4ade80',
            color: '#1a1a1a',
            fontSize: 9,
            minWidth: 16,
            height: 16,
            fontWeight: 700,
          },
        }}
      >
        <NotificationIcon width={20} />
      </Badge>
    </IconButton>
  );
};
